import Button from 'atoms/button'
import Image from 'atoms/image';

export default function PartnerHero() {
  return (
    <>
      <div className="partner-fold">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-4">
              <p className="text-white">Locaties</p>
              <h1 className="text-white">Fysiotherapie4all</h1>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .partner-fold {
          padding: 0;
          background-color: #16a8f4;
          /*background: url(/img/backgrounds/specialismen-above-fold.png);*/
          background-size: cover;
          background-repeat: no-repeat;
          background-position: bottom center;
          /*min-height: 50vh;*/
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 40px;
        }

        @media screen and (max-width: 375px) {
          .partner-fold {
            /*min-height: 45vh;*/
            margin-bottom: 0px;
          }
        }
      `}</style>
    </>
  )
}
